import axios, { AxiosResponse } from 'axios';
import { VITE_API_PATH } from '../constants';
import {
  AgreementResponse,
  CartPriceRequest,
  CreateCaseParams,
  PriceProduct,
  PriceResponse,
  ProductWithDiscount,
  ShopForm,
} from '../types/api_shared_types';
import { BrevFranOssContent } from '../types/cms_shared_types';
import { Product } from '../types/webshop';

const api = axios.create({
  baseURL: VITE_API_PATH,
});

export const apiPing = async () => {
  const url = '/ping';
  return api.get(url);
};

export const apiGetCmsContent = async (lang: string, contentName: string) => {
  const url = `/${lang}/${contentName}`;
  return api.get(url);
};

export const apiGetBrevFranOssCmsContent = async (lang: string): Promise<AxiosResponse<BrevFranOssContent>> => {
  return apiGetCmsContent(lang, 'brev-fran-oss');
};

export const apiCreateCase = async (params: CreateCaseParams): Promise<AxiosResponse> => {
  const url = '/cases';
  return api.post(url, params);
};

export const apiCreateCaseWithoutWaiting = (params: CreateCaseParams) => {
  fetch(`${VITE_API_PATH}/cases`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
    keepalive: true,
  });
};

export const apiGetPrice = async (
  product: PriceProduct,
  products?: Product[],
): Promise<AxiosResponse<PriceResponse>> => {
  const url = '/prices';
  return api.post(url, { product, products });
};

export const apiGetCartPrice = async (request: CartPriceRequest): Promise<AxiosResponse<ProductWithDiscount[]>> => {
  const url = '/prices/cart';
  return api.post(url, request);
};

export const apiPostAgreement = async (params: ShopForm): Promise<AxiosResponse<AgreementResponse>> => {
  const url = '/agreement';
  return api.post(url, params);
};

interface PollContractResponse {
  signedStatus: string;
}

export const apiPollContractStatus = async (contractId: number): Promise<AxiosResponse<PollContractResponse>> => {
  const url = `/contracts/${contractId}`;
  return api.get(url);
};
